/**
 * Severity / SLA-tone style lookups.
 *
 * Extracted to a single place so OversightConsole, IncidentRegister,
 * ModelPerformance (and any future surface that grades a row by risk)
 * draw their colours from one map. Lookups beat nested ternaries on
 * readability and accept new tones without touching every site.
 */

// Severity dot background — used on row chips, drawer headers, etc.
export const SEVERITY_DOT = {
  high: "bg-risk-high",
  med:  "bg-risk-med",
  low:  "bg-risk-low",
};

// Severity text + bg combo (used on small inline pills).
export const SEVERITY_PILL = {
  high: "bg-risk-high/10 text-risk-high",
  med:  "bg-risk-med/10  text-risk-med",
  low:  "bg-risk-low/10  text-risk-low",
};

// SLA tone derived from time-remaining vs total.
export const SLA_TEXT_CLASS = {
  breach: "text-risk-high font-semibold",
  warn:   "text-gold-700 font-semibold",
  ok:     "text-ink-primary",
};

export function sevDot(severity) {
  return SEVERITY_DOT[severity] || SEVERITY_DOT.low;
}

export function sevPill(severity) {
  return SEVERITY_PILL[severity] || SEVERITY_PILL.low;
}

export function slaTextClass(tone) {
  return SLA_TEXT_CLASS[tone] || SLA_TEXT_CLASS.ok;
}

// Ordinal rank for severity sort comparators.
const SEVERITY_RANK = { high: 3, med: 2, low: 1 };
export function severityRank(severity) {
  return SEVERITY_RANK[severity] || 0;
}

// SLA tone from time-remaining (hours) vs total (hours).
export function slaTone(remaining, total) {
  if (remaining <= 0) return "breach";
  if (remaining <= Math.max(2, (total || 0) * 0.25)) return "warn";
  return "ok";
}
